<template>
  <div>
    <vs-popup :title="$t(popupTitle)" :active.sync="showModal">
      <form>
        <div class="vx-row mb-2">
          <div class="vx-col lg:w-1/2 sm:w-1/2 w-full mt-1">
            <div class="w-full">
              <vs-input
                class="inputx"
                v-model="amount"
                v-validate="{ required: true }"
                name="amount"
                :readOnly="readOnly"
                :label="$t('PaymentAmount')"
              />
              <span class="text-danger text-sm" v-show="errors.has('amount')">{{
                errors.first("amount")
              }}</span>
            </div>
          </div>
          <div class="vx-col lg:w-1/2 sm:w-1/2 w-full mt-1">
            <label class="vs-input--label">{{ $t("PartyType") }}</label>
            <div class="w-full">
              <v-select
                label="name"
                name="saleInterface"
                :options="saleInterfaces"
                :reduce="(x) => x.value"
                v-validate="{ required: true }"
                :value="
                  model.saleInterface
                    ? saleInterfaces.filter(
                        (x) => x.value == model.saleInterface
                      )[0].name
                    : ''
                "
                @input="selectSaleInterface"
                :disabled="readOnly"
                dir="rtl"
              >
              </v-select>
              <span
                class="text-danger text-sm"
                v-show="errors.has('saleInterface')"
                >{{ errors.first("saleInterface") }}</span
              >
            </div>
          </div>
          <div class="vx-col lg:w-1/2 sm:w-1/2 w-full mt-1">
            <label class="vs-input--label">{{ $t("BankType") }}</label>
            <div class="w-full">
              <v-select
                label="name"
                name="bankType"
                :options="bankTypes"
                :reduce="(x) => x.value"
                v-validate="{ required: true }"
                :value="
                  model.bankType
                    ? bankTypes.filter((x) => x.value == model.bankType)[0].name
                    : ''
                "
                @input="selectBankType"
                :disabled="readOnly"
                dir="rtl"
              >
              </v-select>
              <span
                class="text-danger text-sm"
                v-show="errors.has('bankType')"
                >{{ errors.first("bankType") }}</span
              >
            </div>
          </div>
          <div class="vx-col lg:w-1/2 sm:w-1/2 w-full mt-1">
            <div class="w-full">
              <vs-input
                class="inputx"
                v-model="model.referenceId"
                v-validate="{ required: true }"
                name="referenceId"
                :readOnly="readOnly"
                :label="$t('ReferenceId')"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('referenceId')"
                >{{ errors.first("referenceId") }}</span
              >
            </div>
          </div>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col w-full mt-1">
            <div class="w-full">
              <vs-input
                class="inputx mb-4 mt-1"
                v-model="model.description"
                :readOnly="readOnly"
                :label="$t('Description')"
              />
            </div>
          </div>
        </div>
        <div class="vx-row mb-2" v-if="!readOnly && show">
          <div class="vx-col w-full">
            <vue-upload-multiple-image
              @upload-success="uploadImageSuccess"
              @before-remove="beforeRemove"
              @edit-image="editImage"
              :data-images="images"
              :maxImage="1"
              :dragText="$t('DragAndDrop')"
              :browseText="$t('UploadImage')"
              :showPrimary="false"
            ></vue-upload-multiple-image>
          </div>
        </div>
        <div class="vx-row mt-2">
          <div class="vx-col w-full">
            <vs-button
              type="filled"
              class="float-right"
              @click.prevent="submitPayment()"
              :disabled="disabled"
              v-if="!readOnly"
              >{{ $t("Submit") }}</vs-button
            >
          </div>
        </div>
      </form>
    </vs-popup>
  </div>
</template>
<style lang="scss">
#order-payments .image-container {
  width: 100% !important;
}
</style>
<script>
import { URLS_CONSTANTS } from "../../../../config";
import { mapActions } from "vuex";
import vSelect from "vue-select";
import VueUploadMultipleImage from "vue-upload-multiple-image";
import { Validator } from "vee-validate";
const dict = {
  custom: {
    amount: {
      required: "لطفا مبلغ پرداختی را وارد نمایید.",
    },
    saleInterface: {
      required: "لطفا شخصیت طرف تجاری را وارد نمایید.",
    },
    bankType: {
      required: "لطفا بانک را وارد نمایید.",
    },
    referenceId: {
      required: "لطفا شناسه مرجع را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "basketManagement_WebSiteBaskets_OrderPaymentPopup",

  props: {
    show: { default: false },
    model: {
      default: {},
    },
    keywords: {},
  },
  data() {
    return {
      popupTitle: "",
      saleInterfaces: [
        { name: "B2B", value: "1" },
        { name: "B2C", value: "2" },
      ],
      bankTypes: [
        { name: "ملت", value: "1" },
        { name: "ملی", value: "2" },
        { name: "مسکن", value: "3" },
        { name: "سپه", value: "4" },
        { name: "پاسارگاد", value: "5" },
        { name: "پارسیان", value: "6" },
        { name: "ایران خودرو", value: "7" },
        { name: "اسنپ‌پی", value: "8" },
      ],
      images: [],
      disabled: false,
      amount: null,
      readOnly: false,
      URLS_CONSTANTS: URLS_CONSTANTS,
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      createOrderPayment: "bankPayments/createOrderPayment",
      updateOrderPayment: "bankPayments/updateOrderPayment",
    }),
    selectSaleInterface(val) {
      this.model.saleInterface = val;
    },
    selectBankType(val) {
      this.model.bankType = val;
    },
    uploadImageSuccess(formData, index, fileList) {
      this.model.paymentAttachmentImageContent = fileList[index].path;
    },
    beforeRemove(index, done) {
      done();
      this.model.paymentAttachmentImageContent = "";
    },
    editImage(formData, index, fileList) {
      this.model.paymentAttachmentImageContent = fileList[index].path;
    },
    submitPayment() {
      this.model.basketId = this.$route.params.id;
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.disabled = true;
          if (this.model.id != null) {
            var newModel = {
              id: this.model.id,
              amount: this.model.amount,
              saleInterface: this.model.saleInterface,
              bankType: this.model.bankType,
              referenceId: this.model.referenceId,
              description: this.model.description,
              paymentAttachmentImageContent:
                this.model.paymentAttachmentImageContent.uri,
            };
            this.updateOrderPayment(newModel).then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ویرایش شد!",
                showConfirmButton: false,
                timer: 2000,
              });
              this.$emit("finish");
              this.model = {};
              this.$validator.reset();
            });
            this.disabled = false;
          } else {
            this.createOrderPayment(this.model).then(() => {
              this.$emit("finish");
              this.model = {};
              this.$validator.reset();
            });
            this.disabled = false;
          }
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show) {
        if (this.model.id) {
          this.popupTitle = "EditCashPayment";
          this.amount = this.model.amount.toLocaleString();
          //
          if (
            this.model.paymentAttachmentImageContent &&
            this.model.paymentAttachmentImageContent.uri != null
          ) {
            this.images.push({
              path:
                this.URLS_CONSTANTS.assets +
                "PaymentAttachmentImageContent/" +
                this.model.paymentAttachmentImageContent.uri,
            });
          } else {
            this.images = [];
          }
          //
          if (this.model.paymentType == 1) {
            this.readOnly = true;
          } else {
            this.readOnly = false;
          }
          ///
        } else {
          this.popupTitle = "AddCashPayment";
          this.readOnly = false;
          this.images = [];
        }
        ///
      } else {
        this.amount = null;
        this.images = [];
      }
      ///
      this.$validator.reset();
    },
    amount(value) {
      if (value) {
        var n = parseFloat(value.replace(/,/g, ""), 10);
        this.amount = n.toLocaleString();
        this.model.amount = this.amount.replace(/,/g, "");
      } else {
        this.amount = null;
        this.model.amount = null;
      }
    },
  },
  components: {
    "v-select": vSelect,
    VueUploadMultipleImage,
  },
};
</script>
